import { KnowledgeSectionService } from './../knowledge-section.service';
import { Component, OnInit, TemplateRef, OnDestroy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { environment } from 'src/environments/environment';
import { ToastrService } from 'ngx-toastr';
import { NgxSpinnerService } from 'ngx-spinner';
import { SwalService } from '../../../../shared/services/swal/swal.service';
import { interval, Subject, Subscription } from 'rxjs';
import { takeUntil, flatMap } from 'rxjs/operators';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { Title, DomSanitizer } from '@angular/platform-browser';
import encodeUrl from 'src/app/shared/sharer';
import { GoogleAnalyticsService } from 'src/app/shared/services/google-analytics.service';

@Component({
    selector: 'app-case-study-detail',
    templateUrl: './case-study-detail.component.html',
    styleUrls: ['./case-study-detail.component.scss'],
})
export class CaseStudyDetailComponent implements OnInit, OnDestroy {
    bsModalRef: BsModalRef;
    caseStudyId: any;
    caseStudyDetails: any;
    similarCaseStudy: any;
    mainImg: any;
    sliderImages: any;
    imageBasePath = environment.imgUrl;
    similarAppSliderConfig = {
        slidesToShow: 5,
        // slidesToScroll: 1,
        autoplay: false,
        // autoplaySpeed: 5000,
        dots: false,
        arrows: false,
        vertical: true,
        infinite: true,
        cssEase: 'ease-in-out',
    };
    slideConfigMainBanner = {
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: true,
        asNavFor: '.slider-nav',
        cssEase: 'ease-in-out',
    };
    slideConfigMainBannerSubImages = {
        slidesToShow: 3,
        slidesToScroll: 1,
        asNavFor: '.slider-for',
        centerMode: true,
        focusOnSelect: true,
        autoplay: true,
        autoplaySpeed: 5000,
        infinite: true,
        cssEase: 'ease-in-out',
        lazyLoad: 'onDemand',
        arrows: false,
    };
    slideConfigMainBannerWithTwoImages = {
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: true,
        cssEase: 'ease-in-out',
        autoplay: true,
        autoplaySpeed: 5000,
        infinite: true,
    };
    page = 1;
    pageSize = 1;
    unsubscribeCaseStudies = new Subject();
    unsubscribeCaseStudies1 = new Subject();
    caseStudyImages = [];
    intervalObs: Subscription;
    currentUrl: string;
    sharingUrl = environment.sharingUrl;
    socialShareUrl = '';
    constructor(
        private route: ActivatedRoute,
        private service: KnowledgeSectionService,
        private toastr: ToastrService,
        private spinner: NgxSpinnerService,
        private swalService: SwalService,
        private modalService: BsModalService,
        private router: Router,
        private titleService: Title,
        private sanitized: DomSanitizer,
        private gaService: GoogleAnalyticsService
    ) {}

    ngOnInit(): void {
        this.route.params.subscribe((params) => {
            this.caseStudyId = params.id;
            this.currentUrl = window.location.href;
            this.getcaseStudyDetails();
        });
        this.callingInterval();
    }

    callingInterval() {
        this.intervalObs = interval(10 * 1000)
            .pipe(
                flatMap(() =>
                    this.service
                        .getSimilarCaseStudyDetails(
                            this.caseStudyId,
                            this.page,
                            this.pageSize
                        )
                        .pipe(takeUntil(this.unsubscribeCaseStudies))
                )
            )
            .subscribe((data) => {
                this.page += 1;
                if (data.body.page == 1) {
                    this.page = 2;
                }
                if (data.body['casestudies'][0]) {
                    this.similarCaseStudy.splice(0, 1);
                    this.similarCaseStudy.push(data.body['casestudies'][0]);
                }
                // console.log(this.similarCaseStudy,"this.similarCaseStudy")
            });
    }

    //   callingInterval(){
    //     const source = interval(10000);
    // const text = 'Your Text Here';
    // this.intervalObs = source.subscribe(val =>{
    //   const caseDetailsSubs:Subscription = this.service.getSimilarCaseStudyDetails(this.caseStudyId,this.page,this.pageSize).subscribe((data)=>{
    //       this.page +=1;
    //       if(data.body.page == 1){
    //         this.page = 2;
    //       }
    //       if(data.body['casestudies'][0]){
    //       this.similarCaseStudy.splice(0, 1)
    //       this.similarCaseStudy.push(data.body['casestudies'][0]);
    //       }
    //       // this.similarCaseStudy = data.body['casestudies'];
    //       console.log(this.similarCaseStudy,"this.similarCaseStudy")

    //     }).add(() => {
    //       caseDetailsSubs.unsubscribe();
    //     })
    //   })
    // }
    // callingInterval(){
    //   this.intervalId = setInterval(()=>{this.opensnack()}, 10000);
    // }
    // opensnack(){
    //   this.service.getSimilarCaseStudyDetails(this.caseStudyId,this.page,this.pageSize).subscribe((data)=>{
    //           this.page +=1;
    //           if(data.body.page == 1){
    //             this.page = 2;
    //           }
    //           if(data.body['casestudies'][0]){
    //           this.similarCaseStudy.splice(0, 1)
    //           this.similarCaseStudy.push(data.body['casestudies'][0]);
    //           }
    //           // this.similarCaseStudy = data.body['casestudies'];
    //           console.log(this.similarCaseStudy,"this.similarCaseStudy")
    //         })

    // }
    addSlide() {
        // this.slides.push({img: "http://placehold.it/350x150/777777"})
    }

    removeSlide() {
        // this.slides.length = this.slides.length - 1;
    }

    getcaseStudyDetails(): void {
        this.service
            .getCaseStudyDetails(this.caseStudyId, this.page, '5')
            .pipe(takeUntil(this.unsubscribeCaseStudies1))
            .subscribe(
                (data: any) => {
                    this.spinner.show();
                    if (data.status === 200) {
                        this.titleService.setTitle(
                            data.body.casestudy.title + ' | Social App Hub'
                        );
                        this.gaService.eventEmitter(
                            'casestudy',
                            'knowledge',
                            data.body.casestudy.title
                        );
                        this.page += 1;
                        this.caseStudyDetails = data.body.casestudy;
                        this.socialShareUrl = this.sharingUrl +'/case-study/'+this.caseStudyDetails._id;
                        this.similarCaseStudy = data.body.related;
                        if (data.body.casestudy.images.length > 0) {
                            this.mainImg = data.body.casestudy.images[0];
                            // this.sliderImages = data.body.casestudy.images;
                            this.multiplyScreenshots(
                                data.body.casestudy.images
                            );
                        }
                    }
                    this.spinner.hide();
                },
                (err) => {
                    this.spinner.hide();
                    this.toastr.error(err.error.message, '');
                }
            );
    }

    selectImg(img: any): void {
        this.mainImg = img;
    }
    comingSoon(template: TemplateRef<any>) {
        this.bsModalRef = this.modalService.show(template, {
            animated: true,
            backdrop: 'static',
            class: 'my-modal',
        });
        // this.swalService.basicInfo('Coming Soon');
    }
    ngOnDestroy() {
        this.intervalObs.unsubscribe();
        this.unsubscribeCaseStudies.unsubscribe();
        this.unsubscribeCaseStudies1.unsubscribe();
    }
    transform(value, length) {
        if (value) {
            if (value.length > length) {
                let data: any = value.replace(/<.*?>/g, '');
                return data.substring(0, length) + '....';
            } else {
                return value;
            }
        }
    }

    multiplyScreenshots(screenshots) {
        // || screenshots.length == 4 || screenshots.length == 5
        if (screenshots.length == 3) {
            this.sliderImages = screenshots.concat(screenshots);
        } else {
            this.sliderImages = screenshots;
        }
        // else if(screenshots.length == 2){
        //   this.sliderImages = screenshots.concat(screenshots);
        //   for(let i=0 ;i<4;i++){
        //   this.sliderImages = this.sliderImages.concat(screenshots)
        // }
        // }
    }
    relatedCaseStudyDetail(data) {
        //   this.router.routeReuseStrategy.shouldReuseRoute = function () {
        //     return false;
        // }
        this.router.onSameUrlNavigation = 'reload';
        this.router.navigate([
            '/knowledge-section/case-study/detail',
            data?._id,
        ]);
    }
    searcRoute(data) {
        this.router.navigate(['/search'], {
            queryParams: { query: data },
        });
    }
    transform1(value) {
        if (value) {
            return this.sanitized.bypassSecurityTrustHtml(value);
        }
    }

    encodeSocialURI(input) {
        return encodeURIComponent(input);
    }
}
